var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7743 22.6388L4.90201 14.7735C4.78747 14.6589 4.70525 14.5376 4.65538 14.4096C4.6055 14.2816 4.58057 14.1451 4.58057 13.9999C4.58057 13.8548 4.6055 13.7182 4.65538 13.5902C4.70525 13.4622 4.78747 13.3409 4.90201 13.2264L12.7937 5.33468C12.9982 5.13022 13.2499 5.02753 13.5488 5.02662C13.8477 5.0257 14.1076 5.13564 14.3284 5.35643C14.5491 5.5754 14.6612 5.83395 14.6644 6.13209C14.6676 6.43023 14.5589 6.6897 14.3381 6.91049L8.35806 12.8952H21.8694C22.1838 12.8952 22.4465 13.0007 22.6575 13.2118C22.8686 13.4228 22.9742 13.6856 22.9742 13.9999C22.9742 14.3143 22.8686 14.577 22.6575 14.7881C22.4465 14.9991 22.1838 15.1047 21.8694 15.1047H8.35806L14.3575 21.1088C14.562 21.3132 14.665 21.5654 14.6667 21.8652C14.6684 22.165 14.5589 22.4229 14.3381 22.6388C14.1191 22.8626 13.8589 22.9746 13.5575 22.9746C13.2562 22.9746 12.9951 22.8626 12.7743 22.6388Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressBack);
export default __webpack_public_path__ + "static/media/pressBack.22c400d2.svg";
export { ForwardRef as ReactComponent };